<script setup>
import GlobalHeader from "@/components/GlobalHeader/GlobalHeader.vue";
import HomePage from "@/pages/HomePage/HomePage.vue";
import GlobalFooter from "@/components/GlobalFooter/GlobalFooter.vue";


</script>

<template>

  <router-view v-slot="{ Component }">
    <div>
      <GlobalHeader/>
      <transition name="fade">
        <component :is="Component"/>
      </transition>
<GlobalFooter/>


    </div>
  </router-view>
</template>

<style scoped>

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active {
  transition: opacity 0.1s ease-out;
}

.fade-leave-active {
  transition: opacity 0.1s ease-in;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}
</style>
